import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Login } from './pages/Login';
import { Closet } from './pages/Closet';
import { Upload } from './pages/Upload';
import { Outfits } from './pages/Outfits';
import { CreateOutfit } from './pages/CreateOutfit';
import { EditOutfit } from './pages/EditOutfit';
import { Community } from './pages/Community';
import { Shares } from './pages/Shares';
import { ShareDetail } from './pages/ShareDetail';
import { ShareOutfit } from './pages/ShareOutfit';
import { Settings } from './pages/Settings';

const PrivateRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Navigate to="/closet" replace />
          </PrivateRoute>
        }
      />
      <Route
        path="/closet"
        element={
          <PrivateRoute>
            <Closet />
          </PrivateRoute>
        }
      />
      <Route
        path="/upload"
        element={
          <PrivateRoute>
            <Upload />
          </PrivateRoute>
        }
      />
      <Route
        path="/outfits"
        element={
          <PrivateRoute>
            <Outfits />
          </PrivateRoute>
        }
      />
      <Route
        path="/community"
        element={
          <PrivateRoute>
            <Community />
          </PrivateRoute>
        }
      />
      <Route
        path="/outfits/create"
        element={
          <PrivateRoute>
            <CreateOutfit />
          </PrivateRoute>
        }
      />
      <Route
        path="/outfits/:id/edit"
        element={
          <PrivateRoute>
            <EditOutfit />
          </PrivateRoute>
        }
      />
      <Route
        path="/outfits/:id/share"
        element={
          <PrivateRoute>
            <ShareOutfit />
          </PrivateRoute>
        }
      />
      <Route
        path="/shares"
        element={
          <PrivateRoute>
            <Shares />
          </PrivateRoute>
        }
      />
      <Route
        path="/shares/:id"
        element={
          <PrivateRoute>
            <ShareDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <PrivateRoute>
            <Settings />
          </PrivateRoute>
        }
      />
      <Route path="/" element={<Navigate to="/outfits" />} />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
